import React, { useEffect } from "react";
import DomoEmbedProgrammaticFiltering from "src/components/embedTypes/domo/DomoEmbedProgrammaticFiltering";
import DomoEmbedPlatform from "src/components/embedTypes/domo/DomoEmbedPlatform";

export default function DomoRouter({ content, config, setError }) {
  useEffect(() => {
    if (!content?.config?.provider) {
      setError("Provider type does not exist.");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content?.config?.provider]);

  return (
    <>
      {config?.type === "IFRAME_EMBED" && <DomoEmbedProgrammaticFiltering content={content} />}
      {config?.type === "JWT_FULL_EMBED" && <DomoEmbedPlatform content={content} />}
    </>
  );
}
